<template>
  <div class="partner">
    <div class="partner-wrap">
      <div class="partner-title">合作伙伴</div>
      <el-carousel arrow="never">
        <el-carousel-item v-for="(item, index) in transformList" :key="index">
          <el-row :gutter="20">
            <el-col v-for="partner in item" :key="partner.logo" class="img-span" :sm="6" :xl="4">
              <img :src="partner.logo" alt="">
            </el-col>
          </el-row>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
</template>

<script>
  import { getPartnerList } from '@/api/common';
  export default {
      name: 'Partner',
      data: () => {
        return {
          pageSize: window.innerWidth < 1600 ? 8 : 12, // 一页显示数量
          partnerList: [], // 合作伙伴列表
        }
      },
      computed: {
        // 转换后的列表
        transformList() {
          const arr = [];

          if (this.partnerList.length) {
            const totalNum = Math.ceil(this.partnerList.length / this.pageSize);

            for (let i = 0; i < totalNum; i ++) {
              arr.push(this.partnerList.slice(i === 0 ? 0 : i * this.pageSize, totalNum === 1 ? this.pageSize : (i + 1) * this.pageSize));
            }

          }
          return arr;
        },
      },
      mounted() {
        this.getList();
      },
      methods: {
        /**
         * 获取合作伙伴列表
         */
        getList() {
          getPartnerList().then(({ data }) => {
            this.partnerList = data;
          })
        },
      }
  };
</script>

<style lang="scss" scoped>
.partner {
  padding: 20px 0;
  background-color: #fff;
  &-wrap {
    margin: 0 auto;
    width: 75.7%;
  }
  &-title {
    padding: 20px 0;
    @include font(#333, 20px, 600);
  }
  /deep/ .el-carousel {
    .img-span {
      // display: inline-block;
      margin-bottom: 15px;
      text-align: center;
      img {
        border-radius: 2px;
      }
      // &:nth-child(6n+6) {
      //   margin-right: 0;
      // }
    }
    &__container {
      height: 200px;
    }
    &__item {
      display: flex;
      flex-wrap: wrap;
    }
  }
}
  
// 小屏
@include mq($small) {
  .partner {
    &-wrap {
      width: 80%;
    }
  }
}
</style>
